import React, { useState } from "react";
import OrderHistory from "../components/OrderHistory";
import Subscriptions from "../components/Subscriptions";
import PortalSession from "../components/PortalSession";
import MonthlyReports from "../components/MonthlyReports";
import { useRoles } from "../components/useRoles";
// import './AccountNavbar.css'; // We'll create this CSS file

const AccountNavbar = () => {
  const [activeTab, setActiveTab] = useState(0);
  const { isAdmin, isPartner } = useRoles();

  const tabs = [
    { label: "Ordrehistorikk", content: <OrderHistory /> },
    { label: "Abonnementer", content: <Subscriptions /> },
    { label: "Innstillinger", content: <PortalSession /> },
    ...(isAdmin || isPartner
      ? [{ label: "Månedlige rapporter", content: <MonthlyReports /> }]
      : []),
  ];

  return (
    <div className="dashboard-container">
      {/* Dashboard Navigation */}
      <div className="dashboard-header">
        {tabs.map((tab, index) => (
          <button
            key={index}
            className={`tab-button ${index === activeTab ? "active" : ""}`}
            onClick={() => setActiveTab(index)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Dashboard Content */}
      <div className="dashboard-content">{tabs[activeTab].content}</div>
    </div>
  );
};

export default AccountNavbar;
